<template>
  <div class="main-inner-blk">
    <div class="invoice-container">
      <div class="invoice-block">
        <div class="generate-block">
          <h2>Generate Invoice</h2>
          <div class="invoice-form">
            <div class="filter-blk">
              <h3>Invoice Date</h3>
              <v-menu v-model="dateModel" :nudge-right="40" :nudge-top="20" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="dateText" readonly dense v-on="on" outlined> </v-text-field>
                </template>
                <!-- :allowed-dates="allowedDates" -->
                <v-date-picker v-model="filters.invoiceDate" color="black" @change="dateModel = false" ></v-date-picker>
              </v-menu>
            </div>
            <div class="filter-blk">
              <h3>Invoice Period</h3>
              <v-menu v-model="dateRangeModal" :nudge-right="40" :nudge-top="20" :close-on-content-click="false" transition="scale-transition" offset-y min-width="280px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="dateRangeText" readonly dense v-on="on" outlined> </v-text-field>
                </template>
<!-- :max="maxDate" -->
                <v-date-picker v-model="dateRangeValue" range color="black" ></v-date-picker>
                
              </v-menu>
            </div>
            <!-- <div class="filter-blk">
              <h3>Invoice Number</h3>
              <v-text-field
                v-model="filters.invoiceNo"
                dense
                clearable
                outlined
                placeholder="Invoice Number"
                :error-messages="invoiceNoError"
                @blur="$v.filters.invoiceNo.$touch()"
                @input="$v.filters.invoiceNo.$touch()"
              >
              </v-text-field>
            </div> -->
            <div class="filter-blk">
              <h3>GST Percentage</h3>
              <v-autocomplete
                placeholder="GST Percentage"
                dense
                v-model="filters.gstPercentage"
                outlined
                clearable
                :items="percentageList"
                :error-messages="gstPercentageError"
                @blur="$v.filters.gstPercentage.$touch()"
                @input="$v.filters.gstPercentage.$touch()"
              ></v-autocomplete>
            </div>
            <!-- <div class="filter-blk"> -->
            <!-- <div class="switch-blk"> -->
            <!-- <span></span> -->
            <!-- <v-checkbox v-model="filters.igst" label="IGST Applicable"></v-checkbox> -->
            <!-- </div> -->
            <!-- </div> -->

            <div class="button-blk">
              <v-btn color="#111827" @click="getPreview">Generate Preview</v-btn>
              <v-btn color="#a93859" @click="clearData">Clear</v-btn>
            </div>
          </div>
        </div>
        <div class="preview-block">
          <InvoicePreview :previewDetails="previewDetails" @generateInvoice="generateInvoice"></InvoicePreview>
        </div>
      </div>
    </div>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>
import moment from "moment";
import InvoicePreview from "./InvoicePreview.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import axios from "@/axios/axios-global";
import Loading from "@/components/common/Loading";
export default {
  name: "InvoiceGenerate",
  components: { InvoicePreview, Loading },
  mixins: [validationMixin],
  validations() {
    return {
      filters: {
        // invoiceNo: { required },
        gstPercentage: { required },
      },
    };
  },
  data() {
    return {
      startdate: moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"),
      enddate: moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD"),
      dateRangeModal: false,
      dateRangeValue: [moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"), moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD")],
      maxDate: moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD"),
      dateModel: false,
      percentageList: [5, 12, 18],
      // invoiceNo: "",
      filters: {
        startdate: moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"),
        enddate: moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD"),
        invoiceDate: moment().format("YYYY-MM-DD"),
        gstPercentage: "",
        igst: false,
      },

      previewDetails: {},

      loading: false,
    };
  },
  watch: {
    dateRangeValue() {
      if (this.dateRangeValue[0]) {
        if (this.dateRangeValue[1]) {
          if (this.dateRangeValue[0] > this.dateRangeValue[1]) {
            this.filters.startdate = moment(this.dateRangeValue[1]).format("YYYY-MM-DD");
            this.filters.enddate = moment(this.dateRangeValue[0]).format("YYYY-MM-DD");
          } else {
            this.filters.startdate = moment(this.dateRangeValue[0]).format("YYYY-MM-DD");
            this.filters.enddate = moment(this.dateRangeValue[1]).format("YYYY-MM-DD");
          }
          this.dateRangeModal = false;
        }
      }
    },
  },
  methods: {
    allowedDates(date) {
      const day = moment(date).date(); // Get the day of the month
      const isThisMonth = moment(date).isSame(moment(), "month");
      return isThisMonth && day >= 5 && day <= 15;
    },
    clearData() {
      this.filters = {
        startdate: moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"),
        enddate: moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD"),
        invoiceDate: moment().format("YYYY-MM-DD"),
        // invoiceNo: "",
        gstPercentage: "",
        igst: false,
      };
      this.dateRangeModal = false;
      this.dateRangeValue = [moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"), moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD")];
      this.$v.$reset();
      this.previewDetails = {};
    },
    async getPreview() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      else {
        this.loading = true;
        let filter = this.filters;
        filter["generate"] = false;
        filter.date = moment(filter.invoiceDate).valueOf();
        filter.startDate = moment(filter.startdate).valueOf();
        filter.endDate = moment(filter.enddate).valueOf();
        filter.gstPercentage = parseInt(filter.gstPercentage);
        const response = await axios.post("invoice/generate", filter);
        console.log(response.data);
        if (response.status == 200) {
          this.previewDetails = response.data;
        } else {
          this.previewDetails = {};
          this.$toasted.show(response.data, {
            position: "bottom-center",
            duration: 4000,
          });
        }
        this.loading = false;
      }
    },
    async generateInvoice() {
      this.loading = true;
      try {
        const payload = {
          date: this.previewDetails.invoiceDate,
          startDate: this.previewDetails.startDate,
          endDate: this.previewDetails.endDate,
          // invoiceNo: this.previewDetails.invoiceNo,
          gstPercentage: this.previewDetails.calculation.percentage,
          igst: this.previewDetails.calculation.isIGST,
          generate: true,
        };
        const response = await axios.post("invoice/generate", payload);
        console.log(response.data);
        if (response.status == 200) {
          this.$toasted.show("Invoice Successfully Generated", {
            position: "bottom-center",
            duration: 4000,
          });
          await this.downloadPDF(response.data);
        } else {
          this.loading = false;
          this.$toasted.show(response.data, {
            position: "bottom-center",
            duration: 4000,
          });
        }
      } catch (error) {
        this.loading = false;
      }
    },
    async downloadPDF(url, filename = "document.pdf") {
      try {
        if (!url || typeof url !== "string") {
          throw new Error("Invalid URL");
        }

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const blob = await response.blob();
        const blobURL = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = blobURL;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobURL);
        this.loading = false;
        this.clearData();
      } catch (error) {
        this.loading = false;
        console.error("PDF download failed:", error);
      }
    },
  },
  computed: {
    dateText() {
      if (this.filters.invoiceDate !== "") {
        return moment(this.filters.invoiceDate).format("LL");
      } else {
        return "";
      }
    },
    dateRangeText() {
      let start = "";
      let end = "";
      if (this.dateRangeValue[0] > this.dateRangeValue[1]) {
        start = moment(this.dateRangeValue[1]).format("MMM DD");
        end = moment(this.dateRangeValue[0]).format("MMM DD");
      } else {
        start = moment(this.dateRangeValue[0]).format("MMM DD");
        end = moment(this.dateRangeValue[1]).format("MMM DD");
      }
      return `${start} ~ ${end}`;
    },
    // invoiceNoError() {
    //   const errors = [];
    //   if (!this.$v.filters.invoiceNo.$dirty) return errors;
    //   !this.$v.filters.invoiceNo.required && errors.push("Invoice Number is required.");
    //   return errors;
    // },
    gstPercentageError() {
      const errors = [];
      if (!this.$v.filters.gstPercentage.$dirty) return errors;
      !this.$v.filters.gstPercentage.required && errors.push("GST Percentage is required.");
      return errors;
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-container {
  height: calc(100vh - 140px);
  overflow-y: auto;
  padding: 10px;
  //   h2 {
  //     text-transform: uppercase;
  //     font-weight: 600;
  //     font-size: 1.5rem;
  //   }
  .invoice-block {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    .generate-block {
      //   flex: 1;
      width: 50%;
      border: 1px solid rgb(215, 215, 215);
      padding: 15px;
      //   background: #f7f7f7;
      border-radius: 10px;
      h2 {
        border-bottom: 1px solid rgb(217, 217, 217);
        padding-bottom: 10px;
      }
      .invoice-form {
        display: flex;
        column-gap: 10px;
        // row-gap: 10px;
        margin: 20px 0;
        flex-wrap: wrap;
        justify-content: space-between;
        .filter-blk {
          width: 48%;
          display: flex;
          flex-direction: column;
          gap: 5px;
          h3 {
            font-weight: bold;
          }
        }
        .button-blk {
          width: 100%;
          display: flex;
          justify-content: center;
          gap: 15px;

          .v-btn {
            color: #fff;
          }
        }
      }
    }
    .preview-block {
      width: 50%;
      // border: 1px solid rgb(231, 231, 231);
      border-radius: 10px;
      padding: 15px;
      background: #f0f0f0;
    }
  }
}

.v-input--selection-controls {
  padding-top: 0;
  margin-top: 0;
}

::v-deep .v-text-field {
  font-size: 13px;
}

::v-deep .v-label {
  font-size: 14px !important;
}

::v-deep .v-text-field input[type="number"]::-webkit-inner-spin-button,
.v-text-field input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

::v-deep .v-text-field input[type="number"] {
  -moz-appearance: textfield; /* For Firefox */
}
</style>
